module.exports = __webpack_public_path__ + "static/img/nvjuese.f00e73f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/nvjuese.png
// module id = C2zu
// module chunks = 1